var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitzerland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SWITZERLAND_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_58945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000057850323811903805810000003697775382374167194_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.0688 0.105469H0.505859V19.6825H34.0688V0.105469Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_58945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.0688 0.105469H0.505859V19.6825H34.0688V0.105469Z",
    fill: "#C6001E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_58945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000057850323811903805810000003697775382374167194__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.0688 0.105469H0.505859V19.6825H34.0688V0.105469Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_58945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.1719 8.05939H15.4529V3.77539H19.1249V8.05939H23.4059V11.7294H19.1249V16.0114H15.4529V11.7294H11.1719V8.05939Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitzerland);
export default __webpack_public_path__ + "static/media/SWITZERLAND.a41356f980488f8186d45b3849f68141.svg";
export { ForwardRef as ReactComponent };